import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Controller } from 'react-hook-form';
import { H4 } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { FormItem, FormGroup, TextInput } from 'components/core/Form';

import './AlternateNamesContainer.scss';

export function AlternateNamesContainer({ className, fields, append, remove, control, text = 'Add another name to this reservation' }) {
	const addField = useCallback(() => {
		append({ firstName: '', lastName: '', key: (fields?.length || 0) + 1 });
	}, [append, fields]);

	return (
		<div className={classnames('alternate-names-container', className)}>
			{fields &&
				fields.map((field, index) => (
					<div
						className="alternate-name-row"
						key={field.id}
					>
						<H4 className="alternate-name-header">
							Additional User
						</H4>
						<FormGroup>
							<FormItem>
								<Controller
									name={`alternateNames.${index}.firstName`}
									control={control}
									render={({ field: controllerField, fieldState }) => (
										<TextInput
											input={{
												name: controllerField.name,
												value: controllerField.value ?? '',
												onChange: controllerField.onChange,
												onBlur: controllerField.onBlur,
											}}
											meta={{
												touched: fieldState.isTouched,
												error: fieldState.error?.message,
												valid: !fieldState.error,
											}}
											id={`alternativeFirstName-${index}`}
											label="Alternate First Name"
										/>
									)}
								/>
							</FormItem>
							<FormItem>
								<Controller
									name={`alternateNames.${index}.lastName`}
									control={control}
									render={({ field: controllerField, fieldState }) => (
										<TextInput
											input={{
												name: controllerField.name,
												value: controllerField.value ?? '',
												onChange: controllerField.onChange,
												onBlur: controllerField.onBlur,
											}}
											meta={{
												touched: fieldState.isTouched,
												error: fieldState.error?.message,
												valid: !fieldState.error,
											}}
											id={`alternativeLastName-${index}`}
											label="Alternate Last Name"
										/>
									)}
								/>
							</FormItem>
						</FormGroup>
						<Link
							type="button"
							onClick={() => remove(index)}
							className="btn-remove-alternate-name"
						>
							Remove
						</Link>
					</div>
				))}
			{fields && fields.length > 0 && <br />}
			<Link
				className="btn-add-alternate-name"
				onClick={addField}
			>
				{text}
			</Link>
		</div>
	);
}

AlternateNamesContainer.propTypes = {
	className: PropTypes.string,
	fields: PropTypes.array,
	append: PropTypes.func,
	remove: PropTypes.func,
	control: PropTypes.object,
	text: PropTypes.string,
};

export default AlternateNamesContainer;
